import { Controller } from "@hotwired/stimulus"

// Sets the dependent select from the chosen source option's data-dependent-value,
// until the user picks the dependent themselves.
export default class extends Controller {
  static targets = ["source", "dependent"]
  static values = { touched: Boolean }

  follow() {
    if (this.touchedValue) return

    const value = this.sourceTarget.selectedOptions[0]?.dataset.dependentValue
    if (value) this.dependentTarget.value = value
  }

  touch() {
    this.touchedValue = true
  }
}
